function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
import fetch from 'isomorphic-fetch';
import url from 'url';
/**
 * Takes a base URL, and a relative URL, and resolves them.
 * @param {string} apiUrl A base URL
 * @param {string} endpoint A relative URL
 * @returns {string} Combined URL of api and endpoint
 */

export function apiUrlResolve(apiUrl, endpoint) {
  return url.resolve(apiUrl, endpoint);
}
/**
* Action for updating locale messages
* @param {Object}  config   configuration options (apiUrl, apiToken)
* @param {String}  method   http method which to use for call
* @param {String}  endpoint enpoint string name
* @param {Object}  data     object which gets serialized to JSON and then send as body
* @return {Object}          declared action
*/

export default function apiCall(_x, _x2, _x3) {
  return _apiCall.apply(this, arguments);
}
function _apiCall() {
  _apiCall = _asyncToGenerator( /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(config, method, endpoint) {
    var data,
      apiUrl,
      response,
      _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = _args.length > 3 && _args[3] !== undefined ? _args[3] : null;
            apiUrl = apiUrlResolve(config.apiUrl, endpoint);
            _context.prev = 2;
            _context.next = 5;
            return fetch(apiUrl, {
              method: method,
              credentials: 'include',
              headers: {
                'Content-type': 'application/json',
                Authorization: "Token token=".concat(config.apiToken)
              },
              body: data ? JSON.stringify(data) : null
            });
          case 5:
            response = _context.sent;
            _context.next = 12;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            console.error("TRANSLATE: Trying to execute API Call to ".concat(config.apiUrl, " ").concat(method, ":").concat(apiUrl, " with data ").concat(JSON.stringify(data || {}), " but got: ").concat(_context.t0.message)); // eslint-disable-line no-console

            return _context.abrupt("return", {});
          case 12:
            if (!/[23]\d{2}/.test(response.status.toString())) {
              _context.next = 16;
              break;
            }
            _context.next = 15;
            return response.json();
          case 15:
            return _context.abrupt("return", _context.sent);
          case 16:
            throw new Error("Invalid response status code: ".concat(response.status, " for ").concat(method, ":").concat(apiUrl, " with data ").concat(JSON.stringify(data || {})));
          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 8]]);
  }));
  return _apiCall.apply(this, arguments);
}